<script setup lang="ts">
import { onMounted } from "vue";
import { useApplicationAlertsStore } from "@/stores/ApplicationAlerts";
import routeManager from "@/router/route-manager";

const alertsStore = useApplicationAlertsStore();

onMounted(() => {
  alertsStore.fetchAlerts();
});
</script>

<template>
  <div v-if="alertsStore.shouldShowInfoBanner" class="bg-blue-500 text-white p-1 text-center">
    <div class="flex items-center justify-between">
      <router-link :to="routeManager.featureNewsPath()" class="flex items-center justify-center text-white flex-1">
        <i class="pi pi-info-circle mr-2"></i>
        <p>{{ alertsStore.infoAlert!.description }}</p>
      </router-link>
      
      <button
        @click="alertsStore.dismissInfoBanner"
        class="ml-2 text-white hover:text-gray-200"
        aria-label="Close banner"
        title="Close banner (won't show again for 24 hours)"
      >
        <i class="pi pi-times"></i>
      </button>
    </div>
  </div>
</template>